<div class="card">
  <div class="card-body">
    <form [formGroup]="searchComponentsForm" class="row">
      <div class="form-group col-lg-2 col-md-2 col-xs-12">
        <label>{{resources.AllocationScaniaUnit}}:</label>
        <div class="input-group">
          <select formControlName="selectedScaniaUnit" class="form-control" required>
            <option value="" disabled="disabled"></option>
            <option value="0">*{{resources.All}}*</option>
            @for (scaniaUnit of scaniaUnitList | async; track scaniaUnit) {
              <option value={{scaniaUnit.id}}>
                {{scaniaUnit.name}} - {{scaniaUnit.description}}
              </option>
            }
          </select>

        </div>
      </div>
      <div class="form-group col-lg-2 col-md-3 col-xs-12">
        <label>{{resources.ProducedFrom}}:</label>
        <div class="input-group">
          <input formControlName="startDate" type="date" placeholder="yyyy-mm-dd" class="form-control" />
        </div>
      </div>
      <div class="form-group col-lg-2 col-md-3 col-xs-12">
        <label>{{resources.ProducedTo}}:</label>
        <div class="input-group">
          <input formControlName="endDate" type="date" class="form-control" placeholder="yyyy-mm-dd"
            [attr.min]="endDateMin" [attr.max]="endDateMax" />
          </div>
        </div>
        <div class="form-group col-md-2 col-xs-12">
          <label>&nbsp;</label>
          <button class="btn btn-primary form-control" type="button" (click)="onSearch()">
            {{resources.ViewData}}
          </button>
        </div>
        <div class="form-group col-md-2 col-xs-12">
          <label>&nbsp;</label>
          <button class="btn btn-primary form-control" type="button"
            (click)="onUpdate()">
            {{resources.Update}}
          </button>
        </div>
        <div class="form-group col-md-2 col-xs-12">
          <label>&nbsp;</label>
          <button class="btn btn-primary form-control always-hover" type="button" (click)="onExportToExcel()">
            {{resources.ExportToExcel}}
          </button>
        </div>
      </form>
    </div>
  </div>




  @if (showData) {
    <div class="panel" style="margin-top: 5px;">
      <div class="panel-body">
        <cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="dataList | async" (sortTriggered)="onSort($event)"
          (filterTriggered)="onFilter($event)" (clearFilterAndSortingTriggered)="onClearFilterAndSorting()"
          [isLoading]="isLoading | async" [dataTotalCount]="totalCount | async"
          [filterExpression]="filterExpression | async">
        </cal-calsiumlist-listing>
        <cal-pagination [paging]="paging | async" (pageChange)="onPaging($event)" [dataTotalCount]="totalCount | async">
        </cal-pagination>
      </div>
    </div>
  }